import React from "react";

interface ErrorModalProps {
  isOpen: boolean;
  title?: string;
  text?: string;
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  isOpen,
  title = "エラー",
  text = "エラーが発生しました。もう一度お試しください。",
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal fixed inset-0 bg-gray-800 bg-opacity-75 flex items-start justify-center pt-10 z-50">
      <div className="bg-white rounded-lg shadow-lg w-2/3 md:w-1/2 lg:w-1/3 p-6 relative">
        {/* Closeボタン */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          &times;
        </button>

        {/* ヘッダー */}
        <div className="flex mb-4">
          <div className="border-l-8 rounded-3xl border-red-500 mr-4"></div>
          <h2 className="text-lg text-red-600 font-black">{title}</h2>
        </div>

        {/* 本文 */}
        <p className="text-gray-600 whitespace-pre-line">{text}</p>

        {/* フッター */}
        <div className="flex justify-end mt-4">
          <button
            onClick={onClose}
            className="bg-gray-700 text-white font-bold py-2 px-4 rounded-3xl hover:bg-opacity-50"
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
